import { render, staticRenderFns } from "./InpatientDashboard.vue?vue&type=template&id=78b45a8a&scoped=true"
import script from "./InpatientDashboard.vue?vue&type=script&lang=js"
export * from "./InpatientDashboard.vue?vue&type=script&lang=js"
import style0 from "./InpatientDashboard.vue?vue&type=style&index=0&id=78b45a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b45a8a",
  null
  
)

export default component.exports